"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constant = require("../Theme/constant");

var _constant2 = require("./constant");

var ChinaTranslation = _propTypes.default.shape({
  termsText: _propTypes.default.string,
  termsLinks: _propTypes.default.arrayOf(_propTypes.default.string)
});

var _default = {
  PropTypes: {
    translation: _propTypes.default.shape({
      headerTitle: _propTypes.default.string,
      termsText: _propTypes.default.string
    }),
    titleColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
    bodyColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
    accessible: _propTypes.default.bool,
    theme: _propTypes.default.string,
    customProperties: _propTypes.default.object,
    isChina: _propTypes.default.bool,
    chinaTranslation: _propTypes.default.arrayOf(ChinaTranslation),
    formRef: _propTypes.default.object,
    onSubmit: _propTypes.default.func,
    fontSize: _propTypes.default.string
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    translation: _constant2.TERMS_AND_CONDITIONS_TRANSLATION,
    accessible: true,
    titleColor: _constant2.TEXT_TYPE.title.color,
    bodyColor: _constant2.TEXT_TYPE.body.color,
    isChina: false,
    onSubmit: function onSubmit() {}
  }
};
exports.default = _default;